import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config/api";

const AnnouncementPopup = () => {
  const [popupData, setPopupData] = useState(null);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/get_popup.php`)
      .then((res) => {
        if (res.data.success) {
          setPopupData(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Popup fetch error:", err);
      });
  }, []);

  if (!popupData) return null;

  return (
    <div style={overlayStyle}>
      <div style={popupStyle}>
        
        <span
          style={closeStyle}
          onClick={() => setPopupData(null)}
        >
          ✖
        </span>

        {popupData.image && (
          <img
            src={popupData.image}
            alt="Announcement"
            style={imageStyle}
          />
        )}
      </div>
    </div>
  );
};

export default AnnouncementPopup;


/* ================= STYLES ================= */

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0,0,0,0.7)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 99999,
};

const popupStyle = {
  position: "relative",
  width: "800px",
  maxWidth: "90%",
  background: "#fff",
  padding: "10px",
  borderRadius: "12px",
};

const closeStyle = {
  position: "absolute",
  top: "-10px",
  right: "-10px",
  background: "#fff",
  width: "30px",
  height: "30px",
  borderRadius: "50%",
  textAlign: "center",
  lineHeight: "30px",
  cursor: "pointer",
  boxShadow: "0 2px 5px rgba(0,0,0,0.3)",
  fontWeight: "bold",
};

const imageStyle = {
  width: "100%",
  borderRadius: "8px",
};